// extracted by mini-css-extract-plugin
module.exports = {"ChatbotName":"BotHead_ChatbotName__wwOfN","inner":"BotHead_inner__uiw6Z","ico":"BotHead_ico__bJp_F"};